import { isAuthToken } from './isAuthToken';

export const getAuthTokenFromQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    const queryParamToken = params.get('token');

    if (queryParamToken) {
        return isAuthToken(queryParamToken) ? queryParamToken : null;
    }

    return null;
};
